import React from 'react';
import { InputSection, Label, Select, Message, EtcInput } from './style';

const JoinPathSection = ({
    joinPath,
    setJoinPath,
    joinPathEtc,
    setJoinPathEtc,
    joinPathMessage,
    setJoinPathMessage,
}) => {
    // 가입경로 변경 핸들러
    const handleJoinPathChange = (e) => {
        setJoinPath(e.target.value);
        if (e.target.value !== '') {
            setJoinPathMessage('');
        }
    };

    return (
        <InputSection>
            <Label htmlFor="joinPath">가입경로</Label>
            <Select id="joinPath" value={joinPath} onChange={handleJoinPathChange}>
                <option value="">선택</option>
                <option value="검색">검색</option>
                <option value="SNS">SNS</option>
                <option value="광고">광고</option>
                <option value="기타">기타</option>
            </Select>

            {joinPathMessage && <Message isError={true}>{joinPathMessage}</Message>}

            {joinPath === '기타' && (
                <EtcInput
                    type="text"
                    placeholder="경로를 직접 입력하세요."
                    value={joinPathEtc}
                    onChange={(e) => setJoinPathEtc(e.target.value)}
                />
            )}
        </InputSection>
    );
};

export default JoinPathSection;
